<template>
  <div class="insta-feed">
    <div class="row">
      <div
        class="col-12 col-sm-3 col-md-4"
        v-for="(f, index) in feeds"
        v-bind:key="f.id"
      >
        <template v-if="f.mediaType == 'VIDEO'">
          <div class="card-photos card-video">
            <div class="img-holder">
              <i class="ri-live-fill icon-insta-type"></i>
              <a href="" v-on:click.prevent="showFeedItemDetail(index)">
                <img
                  v-bind:src="f.thumbnail || f.mediaUrl"
                  class="img-fluid"
                  style="width: 100%"
                />
              </a>
            </div>
          </div>
        </template>

        <template v-if="f.mediaType == 'IMAGE'">
          <div class="card-photos card-image">
            <div class="img-holder">
              <a href="" v-on:click.prevent="showFeedItemDetail(index)">
                <img
                  v-bind:src="f.thumbnail || f.mediaUrl"
                  class="img-fluid"
                  style="width: 100%"
                />
              </a>
            </div>
          </div>
        </template>

        <template v-if="f.mediaType == 'CAROUSEL_ALBUM'">
          <div class="card-photos card-carousel">
            <div class="img-holder">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon-insta-type"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                  d="M20.083 10.5l1.202.721a.5.5 0 0 1 0 .858L12 17.65l-9.285-5.571a.5.5 0 0 1 0-.858l1.202-.721L12 15.35l8.083-4.85zm0 4.7l1.202.721a.5.5 0 0 1 0 .858l-8.77 5.262a1 1 0 0 1-1.03 0l-8.77-5.262a.5.5 0 0 1 0-.858l1.202-.721L12 20.05l8.083-4.85zM12.514 1.309l8.771 5.262a.5.5 0 0 1 0 .858L12 13 2.715 7.429a.5.5 0 0 1 0-.858l8.77-5.262a1 1 0 0 1 1.03 0z"
                  fill="rgba(255,255,255,1)"
                />
              </svg>
              <a href="" v-on:click.prevent="showFeedItemDetail(index)">
                <img
                  v-bind:src="f.thumbnail || f.mediaUrl"
                  class="img-responsive"
                  style="width: 100%"
                />
              </a>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="clearfix"></div>

    <a
      v-cloak
      href
      id="loadMore"
      class="btn btn-primary btn-donate-lg shadow-sm  btn-lg text-uppercase fw-bold rounded-4 rounded px-5 py-3 fs-5 d-table m-auto"
      v-if="showLoadMore && !loadingFeeds"
      v-on:click.prevent="loadMore"
      >VIEW MORE</a
    >

    <!-- <div class="loader loader-no-overlay" v-if="loadingFeeds">
      <div class="loaderinner"></div>
    </div>-->
    <div v-if="loadingFeeds">
      <p class="lead text-info text-center">Loading...</p>
    </div>
    <insta-feed-detail-modal
      :show.sync="showFeedDetail"
      :feeds="feeds"
      :selected-feed-item-index="selectedFeedItemIndex"
    ></insta-feed-detail-modal>
  </div>
</template>

<script>
import axios from "axios";
import InstaFeedDetailModal from "./insta-feed-detail-modal.vue";

export default {
  components: {
    InstaFeedDetailModal,
  },
  props: {
    limit: {
      default: 9,
      type: Number,
    },
  },
  data() {
    return {
      feeds: [],
      loadingFeeds: false,
      nextPageToken: null,
      selectedFeedItemIndex: undefined,
      showFeedDetail: false,
      showLoadMore: false,
    };
  },

  created() {
    this.loadingFeeds = true;
    this.loadFeeds();
  },

  methods: {
    loadFeeds() {
      let url = `/api/social/insta/media/feed?limit=${this.limit}`;

      if (this.nextPageToken) url += `&after=${this.nextPageToken}`;

      return axios.get(url).then((res) => {
        this.loadingFeeds = false;
        this.showLoadMore = res.data.result.paging ? true : false;
        this.nextPageToken = res.data.result.paging?.cursors?.after ?? null;

        res.data.result.media.forEach((m) => {
          m.caption = m.caption.replace(/\n/g, "<br />");
        });

        if (this.feeds.length) {
          this.feeds = [...this.feeds, ...res.data.result.media];
          return;
        }

        this.feeds = res.data.result.media;
      });
    },

    loadMore() {
      if (!this.nextPageToken) return;

      this.showLoadMore = false;
      this.loadingFeeds = true;

      this.loadFeeds();
    },

    showFeedItemDetail(itemIndex) {
      this.showFeedDetail = true;
      this.selectedFeedItemIndex = itemIndex;
    },
  },
};
</script>
